import {
  Box,
  Button,
  TextField,
  FormControl,
  MenuItem,
  Select,
  Checkbox,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { getUserData } from "../../../redux/slices/authSlice";
import MuiAlert from "../../MuiAlert/MuiAlert";
import ParkingHeader from "./ParkingHeader";
import { useNavigate } from "react-router-dom";
import {
  useSaveCustomerVehicleDetailMutation,
  useUpdateCustomerVehicleDetailMutation,
} from "../../../redux/services/VehicleApi";
import { useAppSelector } from "../../../redux/app/hooks";
import { useGetCategoryListMutation } from "../../../redux/services/contactSupportApi";
import { getCustomerId } from "../../../redux/slices/authSlice";
import Loader from "../../../pages/commons/Loading";
import { useLocation } from "react-router-dom";
import { REGEX_CONSTANT } from "../../../environment/AppConstants";

type Props = {
  navigation?: any;
};

const SaveSchema = Yup.object().shape({
  carNumber: Yup.string()
    .required("Car number is required")
    .matches(
      new RegExp(REGEX_CONSTANT.VEHICAL_NUMBER),
      "Invalid vehicle number format. Example format: AB12CD1234"
    ),
  owner: Yup.string()
    .required("Make is required")
    .max(10, "Maximum 10 characters allowed")
    .min(3, "Minimum 3 characters required"),
  vehicleCategory: Yup.string().required("Vehicle Category is required"),
});

const AddVehicle = (props: Props) => {
  const navigationParams: any = useLocation();
  const { editMode, response, isnavigate } = navigationParams.state;
  const [commercialVehicle, setCommercialVehicle] = useState("NO") as any;
  const [isFocus1, setIsFocus1] = useState(false);
  const [isSelected, setSelection] = useState(false);
  const [getVehicleCategory, getVehicleResponse] = useGetCategoryListMutation();
  const [saveVehicleData, saveVehicleDataResponse] =
    useSaveCustomerVehicleDetailMutation();
  const [editVehicleData, editVehicleDataResponse] =
    useUpdateCustomerVehicleDetailMutation();
  const [vehicleData, setVehicleData] = useState([]);
  const userDataRoot: any = useAppSelector(getCustomerId);
  const navigate = useNavigate();
  const [value, setValue] = useState();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;

  const [initialValues, setInitialValues] = useState({
    customerId: "",
    id: "",
    owner: "",
    model: "",
    status: "",
    carNumber: "",
    vehicleCategory: "",
  });

  useEffect(() => {
    if (response) {
      setValue(response.isPrimary);
      setCommercialVehicle(response.isCommercial);
    }
  }, [response]);

  useEffect(() => {
    if (token) {
      getVehicleCategory({ token: token });
    }
  }, [token]);

  useEffect(() => {
    if (getVehicleResponse.isSuccess) {
      let getVehicleData: any = [];
      getVehicleResponse.data &&
        getVehicleResponse?.data.map((obj: any) => {
          getVehicleData.push({
            value: obj.categoryName,
            key: obj.description,
            description: obj.description,
          });
        });
      setVehicleData(getVehicleData);
    }
  }, [getVehicleResponse.isSuccess]);

  const handleSave = (values: any) => {
    if (editMode == true) {
      saveVehicleData({
        token: token,
        payload: {
          vehicleNumber: values.carNumber.toUpperCase()
            ? values.carNumber.toUpperCase()
            : values.carNumber.toUpperCase(),
          makerName: values.owner,
          modelNumber: values.model,
          status: true,
          isPrimary: isSelected,
          customerId: userDataRoot,
          vehicleCategory: values.vehicleCategory,
          isCommercial: commercialVehicle,
        },
      });
    } else {
      editVehicleData({
        token: token,
        payload: {
          customerId: userDataRoot,
          id: response.id,
          makerName: values.owner,
          modelNumber: values.model,
          status: true,
          isPrimary: response.isPrimary ? response.isPrimary : isSelected,
          vehicleNumber: values.carNumber.toUpperCase()
            ? values.carNumber.toUpperCase()
            : values.carNumber.toUpperCase(),
          vehicleCategory: values.vehicleCategory,
          isCommercial: commercialVehicle,
        },
      });
    }
  };

  useEffect(() => {
    if (saveVehicleDataResponse.isSuccess) {
      setStatusCode({
        type: "success",
        code: "VEHICLE_ADDED_SUCCESS",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 3000);
      setTimeout(() => {
        isnavigate === true
          ? navigate("/profile/Booking-detail")
          : navigate("/profile/vehicle");
      }, 4000);
    } else if (saveVehicleDataResponse.isError) {
      let errorData: any = saveVehicleDataResponse?.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      setStatusCode({
        type: "error",
        code: msg,
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
    if (editVehicleDataResponse.isSuccess) {
      setStatusCode({
        type: "success",
        code: "VEHICLE_UPDATED_SUCCESS",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 3000);
      setTimeout(() => {
        navigate("/profile/vehicle");
      }, 4000);
    } else if (editVehicleDataResponse.isError) {
      let errorData: any = editVehicleDataResponse?.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      setStatusCode({
        type: "error",
        code: msg,
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [
    saveVehicleDataResponse.isSuccess,
    saveVehicleDataResponse.isError,
    editVehicleDataResponse.isSuccess,
    editVehicleDataResponse.isError,
  ]);

  useEffect(() => {
    if (response) {
      setInitialValues({
        customerId: response ? response.customerId : "",
        id: response ? response.id : "",
        owner: response ? response.makerName : "",
        model: response ? response.modelNumber : "",
        status: response ? response.status : "",
        carNumber: response ? response.vehicleNumber : "",
        vehicleCategory: response ? response.vehicleCategory : "",
      });
    }
  }, [response]);

  return (
    <div>
      {(saveVehicleDataResponse.isLoading ||
        editVehicleDataResponse.isLoading) && <Loader />}
      <div className=" rounded-[8px] border-2  lg:m-[50px] m-[20px] lg:mx-8 mx-2 p-[20px] lg:p-[32px]">
        <ParkingHeader
          title={editMode == false ? "Edit Vehicle" : "Add Vehicle"}
        />
        {isAlertVisible && (
          <div>
            <MuiAlert
              severity={statusCode?.type!}
              messageType={statusCode?.code!}
            />
          </div>
        )}
        <Formik
          enableReinitialize
          onSubmit={handleSave}
          validationSchema={SaveSchema}
          initialValues={initialValues}
        >
          {({
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            values,
            touched,
            errors,
          }) => (
            <Box className="lg:mx-[110px] md:mx-[60px] mx-[20px]  mt-10 px-[10px]">
              <Box
                className="mt-5"
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box style={{ width: "100%", marginRight: "20px" }}>
                  <Select
                    color="error"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ width: "100%" }}
                    value={values.vehicleCategory}
                    onChange={(event: any) => {
                      setFieldValue("vehicleCategory", event.target.value);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(
                      touched.vehicleCategory && errors.vehicleCategory
                    )}
                    displayEmpty
                    defaultValue={""}
                  >
                    <MenuItem disabled value="">
                      Select Vehicle Category
                    </MenuItem>
                    {vehicleData &&
                      vehicleData.map((vehicleDatas: any) => (
                        <MenuItem
                          key={vehicleDatas.value}
                          value={vehicleDatas.key}
                        >
                          {vehicleDatas.value}
                        </MenuItem>
                      ))}
                  </Select>
                  {touched.vehicleCategory && errors.vehicleCategory ? (
                    <div className="text-red-500">
                      {String(errors.vehicleCategory)}
                    </div>
                  ) : null}
                </Box>
              </Box>
              <Box>
                <Box style={{ width: "100%" }} className="mt-4">
                  <FormControl>
                    <FormLabel color="error">Vehicle Type</FormLabel>
                    <RadioGroup
                      row
                      value={commercialVehicle}
                      onChange={(item: any) => {
                        setCommercialVehicle(item.target.value);
                        setIsFocus1(false);
                      }}
                    >
                      <FormControlLabel
                        value="NO"
                        control={<Radio color="error" defaultChecked />}
                        label="Private"
                      />
                      <FormControlLabel
                        value="YES"
                        control={<Radio color="error" />}
                        label="Commercial"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
              <Box style={{ width: "100%" }} className="mt-5">
                <TextField
                  fullWidth
                  variant="outlined"
                  label={"Vehicle Number"}
                  color="error"
                  focused
                  placeholder="Vehicle Number"
                  name="carNumber"
                  value={values.carNumber}
                  onChange={handleChange("carNumber")}
                  onBlur={handleBlur("carNumber")}
                  inputProps={{ style: { textTransform: "uppercase" } }}
                  error={Boolean(touched.carNumber && errors.carNumber)}
                  helperText={touched.carNumber && errors.carNumber}
                />
              </Box>
              <Box style={{ width: "100%" }} className="mt-5">
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Make"
                  color="error"
                  placeholder="Make (e.g. Kia)"
                  value={values.owner}
                  name="owner"
                  onChange={handleChange("owner")}
                  onBlur={handleBlur("owner")}
                  error={Boolean(touched.owner && errors.owner)}
                  helperText={touched.owner && errors.owner}
                />
              </Box>
              <Box style={{ width: "100%" }} className="mt-5">
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Model (optional)"
                  color="error"
                  placeholder="Model (optional)"
                  value={values.model}
                  onChange={handleChange("model")}
                  onBlur={handleBlur("model")}
                  error={Boolean(touched.model && errors.model)}
                />
              </Box>
              <Box style={{ width: "100%" }} className="mt-2">
                <Checkbox
                  color="error"
                  checked={value ? value : isSelected}
                  onClick={() =>
                    setSelection(
                      isSelected == false
                        ? true
                        : isSelected == true
                        ? false
                        : true
                    )
                  }
                />
                <span className="">Set as Primary Vehicle</span>
              </Box>
              <Box
                className="justify-center md:justify-end mb-6 rounded-lg font-semibold"
                style={{
                  width: "100%",
                  display: "flex",
                  marginTop: "20px",
                  marginBottom: "40px",
                }}
              >
                <Button
                  style={{
                    marginLeft: "10px",
                  }}
                  variant="contained"
                  color="error"
                  size="large"
                  disabled={commercialVehicle == undefined ? true : false}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddVehicle;
